import styled from 'styled-components'

const UnexpectedError = styled.div`
  background-color: #A33C4E;
  padding: 1rem;
  font-weight: bold;
  margin-bottom: 1rem;
  text-align: center;

  a {
    color: inherit;
    text-decoration: underline;
  }
`;

export default UnexpectedError